import { render } from "./CreateAccount.vue?vue&type=template&id=4d1ab7ae"
import script from "./CreateAccount.vue?vue&type=script&lang=js"
export * from "./CreateAccount.vue?vue&type=script&lang=js"

import "./CreateAccount.vue?vue&type=style&index=0&id=4d1ab7ae&lang=css"
script.render = render

export default script